import { ExperienceRetriever } from '../experience-retriever/experience-retriever';
import { ParametersExtractor } from '../parameters-extractor/parameters-extractor';
import globalConfig from '../../../../common/js/config';
import { ExperienceEntryPoint } from './experience-entry-point';
import { CreativeTrackingService } from '../services/creative-tracking/creative-tracking-service';
import { createContainerDimensionRetriever } from '../ad-container/ad-container-factory';
import { IsProgrammaticRetriever } from '../is-programmatic-retriever/is-programmatic-retriever';
import { PayloadBuilderRedirectStrategy } from '../payload-builder-strategies/payload-builder-strategy-redirect';
import { ExperienceEntryPointTrackingHandler } from '../handlers/creative-tracking/experience-entry-point-tracking-handler';
import { PlayerTrackingHandler } from '../handlers/creative-tracking/player-tracking-handler';
import { AdContainerUnloadHandler } from '../handlers/ad-container-unload-handler';
import { MotionlyReadyEventHandler } from '../handlers/motionly-ready-event-handler';
import { ViewabilityObserverFactory } from '../services/viewability-observer/viewability-observer-factory';
import { TrackingDisablingHelper } from '../helpers/tracking-disabling-helper';
import { ClickActionHandler } from '../handlers/click-action-handler';
import { OcsIdentityHandler } from '../handlers/ocs-identity-handler';
import { FormatNotifier } from '../format-notifier/format-notifier';

const aWindow = window;
const parametersExtractor = new ParametersExtractor();
const {
  adContainer,
  retriever: containerDimensionRetriever
} = createContainerDimensionRetriever(aWindow);
const isProgrammaticRetriever = new IsProgrammaticRetriever(
  parametersExtractor,
  aWindow
);

export const initMain = () => {
  const experienceEntryPoint = new ExperienceEntryPoint(
    experienceRetriever,
    creativeTrackingService,
    parametersExtractor,
    adContainer,
    viewabilityObserverFactory
  );

  const isTrackingDisabled = TrackingDisablingHelper.isTrackingDisabled();
  const formatNotifier = new FormatNotifier(aWindow);

  const experienceEntryPointTrackingHandler = isTrackingDisabled
    ? null
    : new ExperienceEntryPointTrackingHandler(
        experienceEntryPoint,
        creativeTrackingService
      );

  const handlers = [
    new ClickActionHandler(experienceEntryPoint, adContainer),
    ...(experienceEntryPointTrackingHandler
      ? [
          new PlayerTrackingHandler(
            experienceEntryPoint,
            creativeTrackingService,
            parametersExtractor
          )
        ]
      : []),
    new AdContainerUnloadHandler(experienceEntryPoint, adContainer),
    new OcsIdentityHandler(experienceEntryPoint, aWindow),
    new MotionlyReadyEventHandler(formatNotifier, experienceEntryPoint)
  ];

  experienceEntryPointTrackingHandler?.sendCreativeInit();

  experienceEntryPoint.start(aWindow);
};

const experienceRetriever = new ExperienceRetriever(
  parametersExtractor,
  containerDimensionRetriever,
  isProgrammaticRetriever,
  {
    experienceRouteUrl: [globalConfig.MS_ADS_URL, 'creative/experience'].join(
      '/'
    )
  }
);

const payloadBuilderStrategy = new PayloadBuilderRedirectStrategy(
  containerDimensionRetriever,
  parametersExtractor
);
const creativeTrackingService = new CreativeTrackingService(
  payloadBuilderStrategy
);
const viewabilityObserverFactory = new ViewabilityObserverFactory(
  aWindow,
  adContainer,
  parametersExtractor
);

initMain();
